import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { makeApiRequests } from '../../../../../helpers/api';
import { ENDPOINTS } from '../../../../../helpers/constants';
import RichTextEditor from '../../../../common/rich-text-editor/RichTextEditor';
import CustomerSurvey from '../../../../common/customer-survey/CustomerSurvey';

const CustomerGeneralInfo = ({ customer, onCustomerUpdate, editable = true }) => {
  const [updatingCustomer, setUpdatingCustomer] = useState('');
  const oldCustomer = customer.hasOwnProperty('generalInformation');

  const onUpdateCustomerFormSubmit = async generalInformation => {
    setUpdatingCustomer(true);
    const reqBody = oldCustomer
      ? { generalInformation: generalInformation, _id: customer._id }
      : { customerSurvey: generalInformation, _id: customer._id };
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.USERS_UPDATE,
      requestBody: reqBody
    });

    setUpdatingCustomer(false);
    if (error) {
      toast.error(error);
      return;
    }

    toast.success('Info updated succesfully!');
    onCustomerUpdate(response);
  };
  return (
    <div className="d-flex flex-column h-100">
      <Card className="flex-grow-1">
        <Card.Body className="p-0 ">
          {oldCustomer ? (
            <RichTextEditor
              className="border-0"
              rows={10}
              richText={customer?.generalInformation || ''}
              disabled={updatingCustomer}
              editable={editable}
              onSubmit={onUpdateCustomerFormSubmit}
            />
          ) : (
            <CustomerSurvey
              data={customer?.customerSurvey}
              onSubmit={onUpdateCustomerFormSubmit}
              disabled={updatingCustomer}
            />
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default CustomerGeneralInfo;
